// Translation for es
export const es = {
        common: {
            save: 'Guardar',
            cancel: 'Cancelar',
            close: 'Cerrar',
            delete: 'Eliminar',
            edit: 'Editar',
            activate: 'Activar',
            add: 'Añadir',
            saving: 'Guardando...',
            loading: 'Cargando...',
            active: 'ACTIVO',
            inUse: 'En uso',
            test: 'Probara',
            searchApps: 'Buscar aplicaciones...',
            betaBanner: 'BETA - ¡Servicio no disponible aún!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Iniciar sesión',
            signUp: 'Registrarse',
            username: 'Nombre de usuario',
            password: 'Contraseña',
            continue: 'Continuar',
            noAccount: '¿No tienes cuenta?',
            hasAccount: '¿Ya tienes una cuenta?',
            loginError: 'Error de inicio de sesión',
            invalidCredentials: 'Nombre de usuario o contraseña incorrectos',
            rateLimited: 'Demasiados intentos de inicio de sesión. Por favor, espera un momento.',
            sessionExpired: 'Tu sesión ha expirado. Por favor, utiliza un nuevo enlace mágico.',
            magicLinkInvalid: 'El enlace de inicio de sesión no es válido o ha expirado.',
            magicLinkSuccess: '¡Bienvenido! Has iniciado sesión correctamente.',
            magicLinkProcessing: 'Procesando inicio de sesión...',
            connectionError: 'Error de conexión. Por favor, inténtalo de nuevo.'
        },
        profile: {
            myProgress: 'Mi Progreso de Aprendizaje',
            signOut: 'Cerrar Sesión',
            plan: 'Plan: '
        },
        settings: {
            title: 'Configuración',
            tabs: {
                uiSettings: 'Configuración UI',
                systemPrompt: 'Prompt del Sistema',
                llmProfiles: 'Perfiles LLM',
                ttsProfiles: 'Perfiles TTS',
                language: 'Idioma',
            },
            uiSettings: {
                title: 'Interfaz de Usuario',
                themeMode: 'Modo de Tema',
                darkMode: 'Modo Oscuro',
                lightMode: 'Modo Claro',
                themeColor: 'Color del Tema',
                themeColorDesc: 'Elige el color de acento para botones, iconos y destacados',
                background: 'Fondo',
                backgroundDesc: 'Elige un fondo para tu espacio de trabajo',
                selectBackgroundColor: 'Seleccionar color de fondo',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Enfoque',
                    concentration: 'Concentración',
                    relaxation: 'Relajación',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Oscuro Profundo',
                    darkGrey: 'Gris Oscuro',
                    midnightBlue: 'Azul Medianoche',
                    indigo: 'Índigo',
                    darkTeal: 'Verde Azulado Oscuro',
                    brown: 'Marrón',
                    darkRed: 'Rojo Oscuro',
                    deepPurple: 'Púrpura Profundo',
                    pureWhite: 'Blanco Puro',
                    softWhite: 'Blanco Suave',
                    lightGrey: 'Gris Claro',
                    paleBlue: 'Azul Pálido',
                    paleGreen: 'Verde Pálido',
                    paleOrange: 'Naranja Pálido',
                    lavender: 'Lavanda',
                    blueGrey: 'Gris Azulado'
                }
            },
            systemPrompt: {
                label: 'Prompt del Sistema:',
                placeholder: 'Cargando prompt del sistema...',
                emptyError: '¡El prompt del sistema no puede estar vacío!',
                saveSuccess: '✓ ¡Prompt del sistema guardado exitosamente!',
                loadError: 'Error al cargar el prompt del sistema',
                saveError: 'Error al guardar'
            },
            llmProfiles: {
                addButton: '+ Añadir Nueva Conexión',
                newConnection: 'Nueva Conexión',
                editConnection: 'Editar Conexión',
                emptyState: 'No hay conexiones LLM disponibles. Haz clic abajo para añadir una.',
                loadingProfiles: 'Cargando perfiles...',
                nameLabel: 'Nombre *',
                namePlaceholder: 'ej. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Clave API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modelo *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: '¡Todos los campos deben estar completos!',
                saveSuccess: '✓ ¡Perfil guardado exitosamente!',
                deleteConfirm: '¿Realmente quieres eliminar "{name}"?',
                profileNotFound: '¡Perfil no encontrado!',
                loadError: 'Error al cargar perfiles',
                saveError: 'Error al guardar',
                activateError: 'Error al activar',
                deleteError: 'Error al eliminar',
                modelInfo: 'Modelo: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Añadir Nueva Voz',
                newVoice: 'Nueva Voz',
                editVoice: 'Editar Voz',
                emptyState: 'No hay perfiles TTS disponibles. Haz clic abajo para añadir uno.',
                loadingProfiles: 'Cargando perfiles TTS...',
                nameLabel: 'Nombre',
                namePlaceholder: 'ej. Mi ElevenLabs Adam',
                providerLabel: 'Proveedor',
                providerPlaceholder: 'ej. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Clave API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modelo *',
                modelIdPlaceholder: 'ej. eleven_monolingual_v1',
                voiceIdLabel: 'ID Voz',
                voiceIdPlaceholder: 'ej. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: '¡Todos los campos deben estar completos!',
                saveSuccess: '✓ ¡Perfil TTS guardado exitosamente!',
                deleteConfirm: '¿Realmente quieres eliminar "{name}"?',
                loadError: 'Error al cargar perfiles TTS',
                saveError: 'Error al guardar',
                activateError: 'Error al activar',
                deleteError: 'Error al eliminar'
            },
            language: {
                title: 'Elegir Idioma',
                description: 'Selecciona tu idioma preferido para la interfaz de usuario'
            },
        },
        chat: {
            ready: 'Listo',
            start: 'INICIAR',
            stop: 'DETENER',
            initialMessage: 'Haz clic en INICIAR para conversación en tiempo real.',
            listening: 'Escuchando...',
            speaking: 'Thorsten está hablando...',
            userLabel: 'Tú',
            aiLabel: 'IA',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Escribe un mensaje...',
            send: 'Enviar',
            loginRequired: 'Por favor, inicie sesión para utilizar este servicio.',
            loginButton: 'Iniciar sesión ahora',
            magicLinkRequired: 'Por favor, utilice un enlace mágico para iniciar sesión.',
            creditLimitError: 'Su cuota horaria se ha agotado. Actualice su plan (Medium/Premium) para continuar.',
            serviceDisabled: 'El servicio de chat no está disponible actualmente. Por favor, inténtelo más tarde.'
        },
        notifications: {
            error: 'Error',
            success: 'Éxito',
            info: 'Información',
            unknownError: 'Ocurrió un error desconocido'
        },
        cookie: {
            message: 'Este sitio web utiliza cookies para ofrecerle la mejor experiencia de usuario posible.',
            accept: 'Aceptar'
        },
        curriculum: {
                buttonLabel: 'Currículum',
                buttonTitle: 'Mostrar contenido del currículum',
                modalTitle: 'Currículum de {app}',
                sections: {
                    topic: 'Tema del currículum',
                    explanation: 'Explicación para niños',
                    chat: 'Pregunta a la IA',
                    studentProfile: 'Perfil del estudiante'
                },
                chat: {
                    hint: 'Haz una pregunta sobre este tema del currículum. La IA te ayudará a entender por qué es importante.',
                    placeholder: 'Escribe tu pregunta …',
                    inputAria: 'Pregunta para la IA',
                    send: 'Enviar',
                    sending: 'Enviando …',
                    empty: 'La IA no ha devuelto una respuesta. Inténtalo de nuevo.',
                    noTopic: 'No hay contenido del currículum disponible para hacer preguntas.',
                    requestFailed: 'No se pudo generar una respuesta.'
                },
                topic: {
                    empty: 'No hay ningún tema del currículum vinculado a esta micro-aplicación en el backend.',
                    missingDetail: 'Los datos detallados del currículum para esta micro-aplicación aún no están disponibles en el backend.',
                    learningGoals: 'Objetivos de aprendizaje',
                    prerequisites: 'Requisitos previos',
                    unitLabel: 'Unidad',
                    durationLabel: 'Duración',
                    difficultyLabel: 'Dificultad',
                    hours: 'h',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'No hay ninguna explicación para niños disponible.',
                    loadingPrepare: 'La IA está preparando la explicación',
                    loadingExplain: 'La IA está explicando el tema en lenguaje para niños',
                    requestFailed: 'No se pudo generar la explicación para niños.'
                },
                studentProfile: {
                    country: 'País',
                    region: 'Estado / Región',
                    schoolType: 'Tipo de escuela',
                    grade: 'Grado',
                    noContext: 'No hay contexto del estudiante disponible.',
                    childProfileNotFound: 'No se encontró ningún perfil de estudiante en el backend para el inicio de sesión actual.',
                    loginProfileIncomplete: 'El perfil de inicio de sesión aún no contiene un contexto de estudiante completo.',
                    educationContextNotFound: 'Se encontró un perfil de estudiante, pero no hay ninguna asignación de currículum establecida.',
                    noToken: 'No se encontró ningún estudiante con sesión iniciada.'
                },
                errors: {
                    signInRequired: 'Inicia sesión para ver el currículum.',
                    appIdMissing: 'Falta el ID de la aplicación.',
                    loadFailed: 'No se pudieron cargar los datos del currículum.'
                }
            }
    };
